import ProjectsViewState from "backbone/projects/models/projects_view_state.js"
import ProjectsCollectionView from "backbone/projects/views/projects_collection_view.js"
import AddProjectButton from "backbone/projects/views/add_project_button.js"
import PaginationButtonView from "backbone/projects/views/pagination_button_view.js"
import ProjectsSortView from "backbone/projects/views/projects_sort_view.js"
import ProjectsCountView from "backbone/projects/views/projects_count_view.js"
import ScrapePublicationView from "backbone/projects/views/scrape_publication_view.js"
import ImportViaExternalServiceView from "backbone/projects/views/import_via_external_service_view.js"
import NewProjectView from "backbone/projects/views/new_project_view.js"
import ImportStatusView from "backbone/projects/views/import_status_view.js"
import SelectAllCheckboxes from "backbone/shared/views/select_all_checkboxes_view.js"
import Inflector from 'utils/platform/inflector.js'

export default class ProjectsView extends Backbone.View
  events:
    "click .js-new-project"                        : "beginNewProject"
    "click .js-trigger-loading-state"              : "maskLoading"
    "click .js-move-to-top"                        : "bulkMoveToTop"
    "click .js-send-to-bottom"                     : "bulkSendToBottom"
    "click .js-show-delete-modal"                  : "showConfirmDeleteModal"
    "confirm-delete-modal:confirmed"               : "bulkDelete"

  initialize: ->
    @inflector = new Inflector()

    @collection = @options.collection
    @viewState = @options.viewState || new ProjectsViewState

    @collectionView = new ProjectsCollectionView(
      el: @$el.find(".js-projects-list")
      collection: @collection
      skills: @options.skills
      storyFormats: @options.storyFormats
      topics: @options.topics
      viewState: @viewState
    )

    if @collection.models.length == 0
      @collectionView.fetch()
    else
      @collectionView.render()

    new AddProjectButton(
      el: @$el.find(".js-add-project-button"),
      parentViewState: @viewState
    ).render()

    new PaginationButtonView(
      el: @$el.find(".js-pagination-button"),
      collection: @collection,
      hasNextPage: @options.totalCount > @collection.size()
    ).render()

    new ProjectsSortView(el: @$el)
    @projectsCountView = new ProjectsCountView(
      el: @$el.find(".js-projects-counter")
      totalCount: @options.totalCount
      collection: @collection
    ).render()

    @_setupSelectAllView()

  _setupSelectAllView: ->
    @selectAllView = new SelectAllCheckboxes(
      el: @$el
      selectAllCheckbox: "input#select-all"
      childCheckboxes: ".js-project .list-item input"
      selectAllCallback: @_enableBulkDropdown
      childCheckboxCallback: @_enableBulkDropdown
    )
    @selectAllView.updateSelectAll()

  remove: ->
    @selectAllView.remove()
    @collectionView.remove()
    @addFormView.remove() if @addFormView
    super()

  beginNewProject: (e) ->
    e.preventDefault()
    return if @viewState.get("addProjectInProgress")
    $target = $($(e.target).closest(".js-new-project"))
    selectedMethod = $target.data("method")
    switch selectedMethod
      when "scrapeClient"
        @addFormView = new ScrapePublicationView(
          collection: @collection
          onCancel: @cancelAddProjectViewState
          afterSearch: @afterSearch
        )
      when "external"
        @addFormView = new ImportViaExternalServiceView
          collection: @collection
          onCancel: @cancelAddProjectViewState
          afterSearch: @afterSearch
      else
        @addFormView = new NewProjectView
          onCreate: @onCreate
          onCancel: @cancelAddProjectViewState
          urlBased: if selectedMethod == "pdf" then false else true

    @$el.find(".js-project-creation-container").append(@addFormView.render().el)
    @viewState.set(addProjectInProgress: true)

  cancelAddProjectViewState: =>
    @viewState.set(addProjectInProgress: false)

  afterSearch: (options) =>
    itemsReturnedBySearch = options.count
    @viewState.set(addProjectInProgress: false)
    @statusView = new ImportStatusView
      el: @$el.find(".js-status")
      collection: @collection
      showWarning: true
      importComplete: =>
        @collection.refreshTotalCount()
        @statusView.remove()
        count = itemsReturnedBySearch - @collection.createFailedCount()
        contently.flash.notice("Successfully added #{count} projects.")
    @statusView.render()
    @addFormView.remove()

  maskLoading: (e) ->
    $(e.target).maskLoading()

  showConfirmDeleteModal: (e) ->
    numProjects = @inflector.pluralize("project", @selectAllView.selectedCheckboxes().length)
    @$el.find(".js-type-delete-confirmed").text("Delete #{numProjects}")
    contently.ui.showModal("confirm-delete-modal")

  bulkDelete: ->
    @_callBulk("delete")

  bulkMoveToTop: ->
    @_callBulk("move-to-top")

  bulkSendToBottom: ->
    @_callBulk("send-to-bottom")

  onCreate: (projectData) =>
    @collection.add(projectData, at: 0)
    @collection.models[0].set(editMode: true)
    @viewState.set(addProjectInProgress: false)
    if projectData.id
      @collection.refreshTotalCount()
      contently.flash.success "Your new project has been added."
    else
      contently.flash.notice "We were unable to collect the information needed for this project. Please add the missing details below."

  _enableBulkDropdown: ->
    view = @selectAllView || this
    if view.selectedCheckboxes().length > 0
      $(".js-bulk-actions .dropdown-toggle").removeClass("disabled")
    else
      $(".js-bulk-actions .dropdown-toggle").addClass("disabled")

  _bulkUrl: (bulkAction) ->
    "/portfolio/projects/bulk-edit/#{bulkAction}"

  _callBulk: (bulkAction) ->
    self = @
    @$el.maskLoading()
    ids = []
    @selectAllView.selectedCheckboxes().each ->
      ids.push(this.id.replace('-project', ''))
    $.ajax
      url: @_bulkUrl(bulkAction)
      type: 'POST'
      data: {project_ids: ids}
    .success (response) ->
      contently.flash.success response.message
    .error (response) ->
      contently.flash.alert response.message
    .then ->
      location.reload()



// WEBPACK FOOTER //
// ./app/javascript/backbone/projects/views/projects_view.js.coffee